import { TechnicalCategoryBookmark } from '@services';
import { Layout, Row } from 'antd';
import React from 'react';
import { TechnicalCategoryBookmarkMenu, TechnicalCategoryContent } from '@components';

const { Content, Sider } = Layout;

interface IProps {
  orderId: string;
  selectedBookmark?: TechnicalCategoryBookmark;
}

const ServiceOrderBookmark: React.FC<IProps> = ({ orderId, selectedBookmark }) => {
  return (
    <Row>
      <Layout>
        <Sider width={350} theme="light">
          <TechnicalCategoryBookmarkMenu orderId={orderId} />
        </Sider>
        <Content style={{ background: 'white', padding: '0 24px', minHeight: 400 }}>
          {selectedBookmark && (
            <TechnicalCategoryContent category={selectedBookmark.technicalCategory.category} />
          )}
        </Content>
      </Layout>
    </Row>
  );
};

export default ServiceOrderBookmark;
